import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminArchiveView = () => import('@/views/admin/ArchiveView.vue');
export const NAME_ADMIN_ARCHIVE = 'AdminArchive';
export const PATH_ADMIN_ARCHIVE = 'archive';

export const route: DiscoveredRouteModule = {
  id: 'admin.archive',
  scope: 'admin',
  moduleKey: 'archive',
  name: NAME_ADMIN_ARCHIVE,
  path: PATH_ADMIN_ARCHIVE,
  component: AdminArchiveView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_archive'] },
};
